module.exports = __webpack_public_path__ + "static/img/TargetBath-white.9777dd6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logos/home-page-logos/TargetBath-white.png
// module id = /LVw
// module chunks = 0